import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';

class LaborMaterial extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			labmat: {
				DATA_FOR: null,
				SHOP_ID: null
			},
			renderKey: 0
		}
	}	
		
	onChange(accessor, value) {
		var labmat = this.copyObject(this.state.labmat);
		this.setByAccessor(labmat, accessor, value);
		this.mergeState({ labmat: labmat });
	}

	onSubmit(event) {
		this.props.navigate('/Jobtrack/' + this.state.labmat.DATA_FOR + '/' + this.state.labmat.SHOP_ID);
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Labor and Material Data Entry
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={labmatColumns} data={this.state.labmat}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								<Button id="continue" variant="warning" type="submit" className="float-end">Continue</Button>
							  </Col>
							</Form.Group>
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const labmatColumns = [
	{ Header: 'Enter Data For', accessor: 'DATA_FOR', type: 'select', row: 0, col: 0, required: true,
		options: [{ value: null, label: 'Select...' },{ value: 'Labor', label: 'Job Labor' },
			{ value: 'Material', label: 'Job Material' },{ value: 'PartSignOut', label: 'Part Sign Out' }]},
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 0, col: 1, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOPS', order: 'SHOP_ID',
			search: { Operator: 'and', Children: [
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
				{ Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' }
	]}}}
];

export default withRouter(LaborMaterial);
